import { Permissions } from '../constants/permissions'

export type PermissionScope = string | boolean | undefined
export type PermissionsWithScope = Record<string, PermissionScope>

export const getPermissionScope = (
  permissionsWithScope: PermissionsWithScope | undefined,
  permissionName: string,
): PermissionScope => {
  return permissionsWithScope?.[permissionName]
}

export const hasPermission = (
  permissionsWithScope: PermissionsWithScope | undefined,
  permissionName: string,
): boolean => {
  const scope = getPermissionScope(permissionsWithScope, permissionName)
  return scope !== undefined && scope !== null && scope !== false
}

export const hasPermissionScope = (
  permissionsWithScope: PermissionsWithScope | undefined,
  permissionName: string,
  allowedScopes: string[],
): boolean => {
  const scope = getPermissionScope(permissionsWithScope, permissionName)
  if (scope === true) {
    return true
  }
  if (typeof scope !== 'string') {
    return false
  }
  return allowedScopes.includes(scope)
}

/** Есть ли у сессии хотя бы одно выданное право (для входа без привязки к числовым role_id). */
export const hasAnyPermission = (
  permissionsWithScope: PermissionsWithScope | undefined,
): boolean => {
  if (!permissionsWithScope) {
    return false
  }
  return Object.values(permissionsWithScope).some(v => v !== undefined && v !== null && v !== false)
}

/** Видимость заказов шире одного офиса (по scope `access_orders`). */
export function hasBroadOrdersOrgSelect(
  permissionsWithScope: PermissionsWithScope | undefined,
): boolean {
  const s = getPermissionScope(permissionsWithScope, Permissions.ACCESS_ORDERS)
  return s === true || s === 'all' || s === 'brand' || s === 'organization'
}

/** Зафиксировать организацию в фильтрах списков (узкий доступ к заказам). */
export function ordersFilterShouldLockOrganization(
  permissionsWithScope: PermissionsWithScope | undefined,
): boolean {
  return !hasBroadOrdersOrgSelect(permissionsWithScope)
}

/** Колонка массовых действий по рекламациям (раньше только role 16 / ГО). */
export function canDeleteClaimsLikeGoLeader(
  permissionsWithScope: PermissionsWithScope | undefined,
): boolean {
  if (hasPermission(permissionsWithScope, Permissions.ACCESS_ADMIN)) {
    return true
  }
  const s = getPermissionScope(permissionsWithScope, Permissions.ACCESS_ORDERS)
  return s === true || s === 'all'
}
